/**
 * Canonical artifact file paths, relative to a project root.
 *
 * The four font-system paths are imported from `@repo/site-validations` (their
 * source of truth — the validators reference them in error messages), so they
 * can't drift. `THEME_CSS_PATH` is defined here because theme validation is
 * path-agnostic (it takes raw CSS), so the package never names the file.
 *
 * @module
 */
import {
  ASTRO_CONFIG_PATH,
  FONT_MANIFEST_PATH,
  GLOBAL_CSS_PATH,
  LAYOUT_PATH,
} from "@repo/site-validations"

/** The theme token definitions consumed by `validateThemeCss`. */
export const THEME_CSS_PATH = "src/theme/theme.css"

export { ASTRO_CONFIG_PATH, FONT_MANIFEST_PATH, GLOBAL_CSS_PATH, LAYOUT_PATH }
